module.exports = __webpack_public_path__ + "static/img/person_1.aae7f82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/person_1.png
// module id = BTpn
// module chunks = 1